module.exports = __webpack_public_path__ + "static/media/google-play.15d6b612.svg";